import { NavLink } from 'react-router-dom';
import { mangaCategories } from '@/mocks/categories';
import { aboutInfo } from '@/mocks/about';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500">
                <i className="ri-flower-line text-sm text-background-50"></i>
              </div>
              <span className="text-base font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                樱花动漫
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              国内领先的日本漫画在线阅读平台，收录超过5000部漫画作品。让每一位漫画爱好者都能享受阅读的乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快捷导航</h4>
            <div className="flex flex-col gap-2">
              <NavLink to="/" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap">
                首页
              </NavLink>
              <NavLink to="/category/shonen" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap">
                漫画分类
              </NavLink>
              <NavLink to="/about" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap">
                关于我们
              </NavLink>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              {mangaCategories.slice(0, 6).map((cat) => (
                <NavLink
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </NavLink>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-500"></i>
                {aboutInfo.contact.email}
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-500"></i>
                {aboutInfo.contact.phone}
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-500"></i>
                {aboutInfo.contact.address}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 樱花动漫 SakuraComic. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-accent-500 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-accent-500 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-accent-500 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}